import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import {
  Calendar,
  BookOpen,
  Sparkles,
} from 'lucide-react';
import { MonthlyPlanView } from './MonthlyPlanView';
import { PersonalReportTable } from './PersonalReportTable';
import { AtAGlanceView } from './AtAGlanceView';

export const ReportsView: React.FC = () => {
  const { language, t } = useApp();
  const isBn = language === 'bn';

  // Tab Order: 1. Personal Report, 2. Monthly Plan, 3. At a glance
  const [activeTab, setActiveTab] = useState<'personal_sheet' | 'monthly_plan' | 'at_a_glance'>('personal_sheet');

  return (
    <div className="space-y-6 animate-fade-in pb-12">
      {/* Top Report Tab Navigation */}
      <div className="flex items-center gap-1.5 p-1 bg-white dark:bg-[#111827] border border-slate-200/80 dark:border-slate-800 rounded-2xl overflow-x-auto no-scrollbar print:hidden w-full">
        {/* Tab 1: Monthly Report Sheet (Default) */}
        <button
          onClick={() => setActiveTab('personal_sheet')}
          className={`flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-2.5 sm:px-4 py-2 sm:py-2.5 rounded-xl text-xs font-bold whitespace-nowrap transition-all shrink-0 ${
            activeTab === 'personal_sheet'
              ? 'bg-emerald-600 text-white shadow-md shadow-emerald-500/25'
              : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800'
          }`}
        >
          <BookOpen className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" />
          <span className={isBn ? 'font-bangla' : ''}>{isBn ? 'ব্যক্তিগত রিপোর্ট' : 'Personal Report'}</span>
        </button>

        {/* Tab 2: Monthly Plan */}
        <button
          onClick={() => setActiveTab('monthly_plan')}
          className={`flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-2.5 sm:px-4 py-2 sm:py-2.5 rounded-xl text-xs font-bold whitespace-nowrap transition-all shrink-0 ${
            activeTab === 'monthly_plan'
              ? 'bg-emerald-600 text-white shadow-md shadow-emerald-500/25'
              : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800'
          }`}
        >
          <Calendar className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" />
          <span className={isBn ? 'font-bangla' : ''}>{isBn ? 'মাসিক প্ল্যান' : 'Monthly Plan'}</span>
        </button>

        {/* Tab 3: At a Glance (Last) */}
        <button
          onClick={() => setActiveTab('at_a_glance')}
          className={`flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-2.5 sm:px-4 py-2 sm:py-2.5 rounded-xl text-xs font-bold whitespace-nowrap transition-all shrink-0 ${
            activeTab === 'at_a_glance'
              ? 'bg-emerald-600 text-white shadow-md shadow-emerald-500/25'
              : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800'
          }`}
        >
          <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-300 shrink-0" />
          <span className={isBn ? 'font-bangla' : ''}>{isBn ? 'একনজরে' : 'At a Glance'}</span>
        </button>
      </div>

      {/* Tab 1: Personal Monthly Report Table Sheet */}
      {activeTab === 'personal_sheet' && <PersonalReportTable />}

      {/* Tab 2: Monthly Plan View */}
      {activeTab === 'monthly_plan' && <MonthlyPlanView />}

      {/* Tab 3: At a Glance View */}
      {activeTab === 'at_a_glance' && <AtAGlanceView />}
    </div>
  );
};
